import React, { useState } from 'react';
import { Table } from 'antd';
import { useT } from 'hooks/Locale/useT';
import CommentModal from '../Modals/CommentModal';
import { Tag } from 'ui';
import { TagStatus } from 'ui/Tag/types';
import generalHelpers from 'utils/generalHelpers';

interface LearningTableInterface {
    data: any[];
}

const LearningTable: React.FC<LearningTableInterface> = ({ data }) => {
    const t = useT();
    const [showCommentModal, setShowCommentModal] = useState<any>([]);

    const columns = [
        {
            title: t('general.status'),
            dataIndex: 'status',
            render: (status: TagStatus) => (status ? <Tag status={status} /> : null),
        },
        {
            title: t('program.result_comment'),
            render: (_text: string, record: any) => (
                <div
                    className={record?.comment ? 'pointer' : ''}
                    onClick={() => (record.comment ? setShowCommentModal(record.comment) : null)}
                >
                    <i
                        className={
                            'fa-sharp fa-regular fa-comment-check' +
                            (record?.comment ? '' : 'disabled')
                        }
                    ></i>
                </div>
            ),
        },
        {
            title: t('program.total_time_spent'),
            dataIndex: 'timeSpent',
            render: (time: number) => (time ? generalHelpers.toHoursAndMinutes(time) : '-'),
        },
    ];

    return (
        <>
            <Table
                columns={columns}
                dataSource={data}
                rowKey={'id'}
                pagination={{ position: [] }}
            />
            <CommentModal open={showCommentModal} onCancel={setShowCommentModal} />
        </>
    );
};

export default LearningTable;
